/* eslint-disable jsx-a11y/img-redundant-alt,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useTranslation } from 'react-i18next';

// Context
import { useCompareContext } from '@/context/compare';

import {
  toggleCompareTray,
  toggleExpandedCompareTray,
} from '@/braun/Controllers/CompareTrayController';

const CompareHead = () => {
  const { t } = useTranslation();
  const [{ productsCode, openCompare }] = useCompareContext();
  const productsCount = productsCode.length;

  return (
    <div className='bra-compareTray__head' onClick={toggleCompareTray}>
      <h3 className='bra-compareTray__title'>
        <strong>{t('listing:listing.compare.title.label')}</strong> (
        {productsCount}/3)
      </h3>
      <i
        className='bra-icn bra-icn__arrow--down'
        data-class=' bra-icn__arrow--down'
      />
      <button
        type='button'
        className='bra-btnIcon bra-btnIcon--closeTray'
        onClick={() => {
          toggleExpandedCompareTray();
          openCompare(false);
        }}
      >
        <span className='bra-btnIcon__wrap'>
          <i className='bra-icn bra-icn__legacy-close' />
        </span>
      </button>
    </div>
  );
};

export default CompareHead;
